/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AlertCondition } from './AlertCondition';
import {
    AlertConditionFromJSON,
    AlertConditionFromJSONTyped,
    AlertConditionToJSON,
    AlertConditionToJSONTyped,
} from './AlertCondition';

/**
 * 
 * @export
 * @interface CreateAlertRuleRequest
 */
export interface CreateAlertRuleRequest {
    /**
     * 
     */
    machineId?: string;
    /**
     * 
     */
    machinePartId?: string;
    /**
     * 
     */
    sectionType?: CreateAlertRuleRequestSectionTypeEnum;
    /**
     * 
     */
    questionMatch?: string;
    /**
     * 
     */
    condition?: AlertCondition;
    /**
     * 
     */
    severity?: CreateAlertRuleRequestSeverityEnum;
    /**
     * 
     */
    notifyRoles?: Array<string>;
}


/**
 * @export
 */
export const CreateAlertRuleRequestSectionTypeEnum = {
    StatusCheck: 'STATUS_CHECK',
    NumberEntry: 'NUMBER_ENTRY',
    TextResult: 'TEXT_RESULT',
    MultiValue: 'MULTI_VALUE',
} as const;
export type CreateAlertRuleRequestSectionTypeEnum = typeof CreateAlertRuleRequestSectionTypeEnum[keyof typeof CreateAlertRuleRequestSectionTypeEnum];

/**
 * @export
 */
export const CreateAlertRuleRequestSeverityEnum = {
    Info: 'INFO',
    Warning: 'WARNING',
    Critical: 'CRITICAL',
} as const;
export type CreateAlertRuleRequestSeverityEnum = typeof CreateAlertRuleRequestSeverityEnum[keyof typeof CreateAlertRuleRequestSeverityEnum];


/**
 * Check if a given object implements the CreateAlertRuleRequest interface.
 */
export function instanceOfCreateAlertRuleRequest(value: object): value is CreateAlertRuleRequest {
    return true;
}

export function CreateAlertRuleRequestFromJSON(json: any): CreateAlertRuleRequest {
    return CreateAlertRuleRequestFromJSONTyped(json, false);
}

export function CreateAlertRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAlertRuleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'machinePartId': json['machinePartId'] == null ? undefined : json['machinePartId'],
        'sectionType': json['sectionType'] == null ? undefined : json['sectionType'],
        'questionMatch': json['questionMatch'] == null ? undefined : json['questionMatch'],
        'condition': json['condition'] == null ? undefined : AlertConditionFromJSON(json['condition']),
        'severity': json['severity'] == null ? undefined : json['severity'],
        'notifyRoles': json['notifyRoles'] == null ? undefined : json['notifyRoles'],
    };
}

export function CreateAlertRuleRequestToJSON(json: any): CreateAlertRuleRequest {
    return CreateAlertRuleRequestToJSONTyped(json, false);
}

export function CreateAlertRuleRequestToJSONTyped(value?: CreateAlertRuleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'machineId': value['machineId'],
        'machinePartId': value['machinePartId'],
        'sectionType': value['sectionType'],
        'questionMatch': value['questionMatch'],
        'condition': AlertConditionToJSON(value['condition']),
        'severity': value['severity'],
        'notifyRoles': value['notifyRoles'],
    };
}

